import { useFormContext } from 'react-hook-form';

import { CustomFormElement } from '@/components/common';
import { planBuilderConstants } from '@/modules/AdminTools/lib/constants';
import { useSelector } from 'react-redux';

const { EXT_REF, EXT_REF_LABEL } = planBuilderConstants;

const ExternalReference = () => {
  const { register } = useFormContext();

  const planErrors = useSelector((state) => state?.errors?.errors?.updatePlan);

  const extReferenceError = planErrors?.[EXT_REF];

  return (
    <CustomFormElement
      register={register}
      type="text"
      id={EXT_REF}
      name={EXT_REF}
      label={EXT_REF_LABEL}
      error={extReferenceError}
    />
  );
};

export default ExternalReference;
